module.exports = __webpack_public_path__ + "img/尉宏广.fed1bbf5.jpg";